import cookie from "cookie.js";
import { useRouter } from "vue-router";
export default function loginAuth() {
    const router = useRouter()
    const isLogin = () => {
        const accessToken = cookie.get("accessToken")
        // console.log(router.currentRoute)
        if(!accessToken){
            window.location.href = "/workbench/login?path=" + encodeURIComponent(router.currentRoute.value.fullPath)
            return
        }
        return true
    }
    return {
        isLogin
    }
}